(function () {
  'use strict';

  var root = document.querySelector('[data-kentei-app]');
  if (!root) return;

  // 画面の文言（セクションが window.KT_I18N に渡す）。未設定のときは従来の日本語を使う
  var I18N = window.KT_I18N || {};
  function tr(key, fallback) { return I18N[key] || fallback; }

  var config = {
    liffId: root.dataset.liffId || '',
    questionsUrl: root.dataset.questionsUrl,
    productUrl: root.dataset.productUrl || '/collections/kitagunibayu',
    debugMode: root.dataset.debugMode === 'true',
    appsScriptUrl: root.dataset.appsScriptUrl || ''
  };

  var STORAGE_KEY = 'hs_kentei_state_v1';
  var SUBMITTED_KEY = 'hs_kentei_submitted_v1';
  var EXAM_STORAGE_KEY = 'hs_kentei_exam_v1';

  var state = {
    screen: 'boot',
    index: 0,
    score: 0,
    answers: {} // questionId (1-5) -> selected answer letter ("A"-"D")
  };

  var data = null; // loaded questions.json
  var OPTION_LETTERS = ['A', 'B', 'C', 'D'];
  var POINTS_PER_QUESTION = 20;

  function pushEvent(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  // Same as pushEvent, but never throws — a broken GTM tag/trigger firing on
  // this event must not be able to break the surrounding flow. Logs the real
  // error (with the event name), and in debug_mode also shows it on-screen
  // (top-right) so it can be checked without remote-debugging the phone.
  function safePushEvent(name, params) {
    try {
      pushEvent(name, params);
    } catch (err) {
      var message = '[kentei] analytics push failed for "' + name + '" (ignored): ';
      console.warn(message, err);
      if (config.debugMode) {
        var el = root.querySelector('[data-analytics-debug]');
        if (el) {
          el.textContent = 'analytics failed: ' + name + ' / ' + (err && err.message ? err.message : String(err));
          el.hidden = false;
        }
      }
    }
  }

  function saveState() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function loadState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) state = JSON.parse(raw);
    } catch (e) {}
  }

  // exam (submission status/result) is kept separately from state because it
  // is server-authoritative and must survive a page reload too — otherwise a
  // reload while resting on the result screen wipes exam.result in memory,
  // and the app resubmits the exam a second time to the server.
  function saveExam() {
    try {
      sessionStorage.setItem(EXAM_STORAGE_KEY, JSON.stringify(exam));
    } catch (e) {}
  }

  function loadExam() {
    try {
      var raw = sessionStorage.getItem(EXAM_STORAGE_KEY);
      if (raw) exam = JSON.parse(raw);
      // "pending" can only be left over from a submission that was
      // interrupted mid-flight (e.g. the page reloaded while waiting for
      // Apps Script) — resolve it to "idle" so the app retries instead of
      // getting stuck on the loading screen forever.
      if (exam.status === 'pending') exam.status = 'idle';
    } catch (e) {}
  }

  function formatMoney() {}

  // ---- rendering ----

  function questionByNumber(n) {
    return data.questions.find(function (q) { return q.questionId === n; });
  }

  function renderQuestionScreen(scn, q, index) {
    scn.querySelector('[data-cat]').textContent = q.category;
    scn.querySelector('[data-count]').textContent = tr('questionCount', '第__N__問 / __TOTAL__問').replace('__N__', function () { return index + 1; }).replace('__TOTAL__', function () { return data.questions.length; });
    var progressPct = Math.round((index + 1) * (100 / data.questions.length));
    scn.querySelector('[data-bar]').style.width = progressPct + '%';
    var barTrack = scn.querySelector('.kt-bar');
    if (barTrack) barTrack.setAttribute('aria-valuenow', progressPct);
    scn.querySelector('[data-question]').textContent = q.question;

    var optWrap = scn.querySelector('[data-options]');
    optWrap.innerHTML = '';
    q.options.forEach(function (text, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kt-opt';
      btn.setAttribute('data-letter', OPTION_LETTERS[i]);
      btn.innerHTML = '<span class="kt-opt__mk">' + OPTION_LETTERS[i] + '</span><span class="kt-opt__tx"></span>';
      btn.querySelector('.kt-opt__tx').textContent = text;
      optWrap.appendChild(btn);
    });

    var exp = scn.querySelector('[data-explanation]');
    exp.hidden = true;
    scn.querySelector('[data-next-foot]').hidden = true;
    scn.classList.remove('is-answered');

    var previousAnswer = state.answers[q.questionId];
    if (previousAnswer !== undefined) {
      applyAnswerUI(scn, q, previousAnswer, true);
    }
  }

  function applyAnswerUI(scn, q, selectedLetter, silent) {
    scn.classList.add('is-answered');
    var opts = scn.querySelectorAll('.kt-opt');
    opts.forEach(function (opt) {
      var letter = opt.getAttribute('data-letter');
      opt.classList.remove('ok', 'ng');
      if (letter === q.correct) opt.classList.add('ok');
      if (letter === selectedLetter && selectedLetter !== q.correct) opt.classList.add('ng');
    });

    var hit = selectedLetter === q.correct;
    var exp = scn.querySelector('[data-explanation]');
    var verdict = exp.querySelector('[data-verdict]');
    verdict.textContent = hit ? tr('correct', '正解！') : tr('wrong', '惜しい！');
    verdict.style.color = hit ? '#7F8C65' : '#BC7A6D';
    // q.explanation may contain <strong> for emphasis; content is fully authored by us, not user input.
    exp.querySelector('[data-explanation-text]').innerHTML = q.explanation;
    exp.hidden = false;
    scn.querySelector('[data-next-foot]').hidden = false;

    if (!silent) {
      var body = scn.querySelector('.kt-scr__body');
      if (body) body.scrollTop = body.scrollHeight;
    }
  }

  // ---- screen machine ----

  var screens = {};

  function collectScreens() {
    root.querySelectorAll('[data-screen]').forEach(function (scn) {
      screens[scn.dataset.screen] = scn;
    });
  }

  function focusHeading(scn) {
    var h = scn.querySelector('h1, h2');
    if (h) {
      h.setAttribute('tabindex', '-1');
      h.focus({ preventScroll: true });
    }
  }

  function show(key, opts) {
    opts = opts || {};
    Object.keys(screens).forEach(function (k) {
      screens[k].classList.toggle('on', k === key);
    });
    state.screen = key;
    if (!opts.skipHistory) {
      var url = '#' + key;
      if (opts.replace) {
        history.replaceState({ screen: key }, '', url);
      } else {
        history.pushState({ screen: key }, '', url);
      }
    }
    saveState();

    var scn = screens[key];
    if (!scn) return;
    var body = scn.querySelector('.kt-scr__body');
    if (body) body.scrollTop = 0;
    focusHeading(scn);

    if (/^q\d+$/.test(key)) {
      var n = parseInt(key.slice(1), 10);
      renderQuestionScreen(scn, questionByNumber(n), n - 1);
    } else if (key === 'scoring') {
      submitExamResult();
    } else if (key === 'result') {
      renderResult(scn);
    } else if (key === 'form') {
      pushEvent('gift_form_view');
    }
  }

  function goStart() {
    state.score = 0;
    state.answers = {};
    state.startedAt = new Date().toISOString();
    // Identifies this one exam attempt so a retried/duplicated network
    // submission of the same attempt can't create two spreadsheet rows —
    // Apps Script treats a resend with the same token as already handled.
    state.examToken = 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    saveState();
    exam.status = 'idle';
    exam.result = null;
    saveExam();
    pushEvent('kentei_start');
    show('q1');
  }

  // ---- official exam result (server-authoritative) ----
  //
  // The client-side score kept in state.score/applyAnswerUI is per-question UX
  // feedback only ("正解！"/"惜しい！"). The pass/fail result shown to the user
  // always comes from the Apps Script response, never computed locally.
  var exam = { status: 'idle', result: null }; // idle | pending | success | error

  // debugDetail is the raw Apps Script `error`/`message` field — shown only
  // when debug_mode is on. Never pass idToken or LINE user ID into this.
  function setScoringUI(showError, debugDetail) {
    root.querySelectorAll('[data-scoring-loading]').forEach(function (el) {
      el.hidden = !!showError;
    });
    var errEl = root.querySelector('[data-scoring-error]');
    if (errEl) errEl.hidden = !showError;

    var detailEl = root.querySelector('[data-scoring-error-detail]');
    if (detailEl) {
      if (showError && config.debugMode && debugDetail) {
        detailEl.textContent = '送信失敗: ' + debugDetail;
        detailEl.hidden = false;
      } else {
        detailEl.textContent = '';
        detailEl.hidden = true;
      }
    }
  }

  function handleSubmitFailure(serverErrorText) {
    exam.status = 'error';
    saveExam();
    setScoringUI(true, serverErrorText);
  }

  // Debug-only, persistent (not tied to one screen) summary of the exam
  // submission response — shown for both success and failure so a "doPost
  // completed but the UI shows a failure" mismatch can be diagnosed. Never
  // includes idToken, LINE user ID, or the submitted answers.
  function setExamDebugLine(text) {
    if (!config.debugMode) return;
    var el = root.querySelector('[data-exam-debug]');
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
  }

  function formatExamDebugSummary(httpStatus, json) {
    var parts = ['HTTP ' + httpStatus];
    parts.push('success=' + !!(json && json.success === true));
    if (json && json.mode) parts.push('mode=' + json.mode);
    if (json && json.error) parts.push('error=' + json.error);
    else if (json && json.message) parts.push('message=' + json.message);
    return parts.join(' / ');
  }

  function submitExamResult() {
    if (exam.status === 'pending') return; // in-flight; ignore duplicate triggers
    if (exam.status === 'success' && exam.result) {
      show('result', { replace: true });
      return;
    }

    setScoringUI(false);
    exam.status = 'pending';
    saveExam();

    var answers = data.questions.map(function (q) {
      return { questionId: q.questionId, answer: state.answers[q.questionId] };
    });

    var idToken = null;
    try {
      if (window.liff && window.liff.getIDToken) idToken = window.liff.getIDToken();
    } catch (e) {
      console.warn('[kentei] liff.getIDToken() failed before exam submission:', e);
    }

    var payload = {
      idToken: idToken,
      answers: answers,
      startedAt: state.startedAt || null,
      finishedAt: new Date().toISOString(),
      examToken: state.examToken || null
    };

    if (!config.appsScriptUrl) {
      console.error('[kentei] Cannot submit exam result: no Apps Script URL configured.');
      handleSubmitFailure('Apps Script URL未設定');
      return;
    }

    // Mobile connections — especially inside LINE's in-app browser — sometimes
    // drop a single request that would otherwise have succeeded. Retry
    // silently on a network-level failure (fetch() rejecting, or a garbled
    // non-JSON response) a couple of times before showing the user anything,
    // so a brief connectivity blip doesn't surface as a false failure. A
    // deterministic server-reported error (success:false) is NOT retried,
    // since resending the same payload would just fail the same way again.
    var RETRY_DELAYS_MS = [1000, 2000];

    function attemptSubmit(attemptNumber) {
      // text/plain avoids a CORS preflight (OPTIONS) that Apps Script web
      // apps typically do not handle; the Apps Script side should read
      // e.postData.contents and JSON.parse it.
      fetch(config.appsScriptUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          // fetch() follows redirects by default, so res.status/res here is
          // already the final response Apps Script Web Apps may redirect through.
          var httpStatus = res.status;
          return res.text().then(function (rawText) {
            var json = null;
            try {
              json = JSON.parse(rawText);
            } catch (e) {
              json = null;
            }
            return { httpStatus: httpStatus, json: json, rawText: rawText };
          });
        })
        .then(function (result) {
          if (!result.json) {
            if (attemptNumber <= RETRY_DELAYS_MS.length) {
              setTimeout(function () { attemptSubmit(attemptNumber + 1); }, RETRY_DELAYS_MS[attemptNumber - 1]);
              return;
            }
            console.error('[kentei] Apps Script response was not valid JSON:', result.rawText);
            setExamDebugLine('JSON parse failed / HTTP ' + result.httpStatus + ' / body: ' + result.rawText.slice(0, 100));
            handleSubmitFailure('JSON parse failed');
            return;
          }

          setExamDebugLine(formatExamDebugSummary(result.httpStatus, result.json));

          var json = result.json;
          if (json.success !== true) {
            console.error('[kentei] Apps Script returned a non-success exam result:', json);
            handleSubmitFailure(json.error || json.message || null);
            return;
          }
          // The server call has already succeeded and been recorded at this
          // point. Everything below is best-effort (analytics, navigation) and
          // must never turn an already-successful submission into a shown
          // failure, so it's isolated in its own try/catch.
          exam.status = 'success';
          exam.result = {
            score: json.score,
            rank: json.rank,
            passed: !!json.passed,
            attemptCount: json.attemptCount
          };
          // Persisted before anything else below runs, so a reload from here
          // on (e.g. while resting on the result screen) never re-submits.
          saveExam();

          // Each analytics call is isolated separately so a failure in one
          // doesn't prevent the other from firing.
          safePushEvent('kentei_complete', {
            score: exam.result.score,
            rank: exam.result.rank,
            attempt_count: exam.result.attemptCount
          });
          safePushEvent(exam.result.passed ? 'kentei_pass' : 'kentei_fail', { score: exam.result.score });

          show('result', { replace: true });
        })
        .catch(function (err) {
          console.error('[kentei] Exam result submission failed (attempt ' + attemptNumber + '):', err);

          // If the server call already succeeded (exam.status was set to
          // 'success' before this threw), never show a false failure —
          // the result is already saved. Just try to display it.
          if (exam.status === 'success' && exam.result) {
            console.warn('[kentei] Error occurred after a successful submission; showing result anyway.', err);
            show('result', { replace: true });
            return;
          }

          if (attemptNumber <= RETRY_DELAYS_MS.length) {
            setTimeout(function () { attemptSubmit(attemptNumber + 1); }, RETRY_DELAYS_MS[attemptNumber - 1]);
            return;
          }

          setExamDebugLine('fetch failed / ' + (err && err.message ? err.message : String(err)));
          handleSubmitFailure(null);
        });
    }

    // A known iOS Safari/WebKit bug (used by LINE's in-app browser too) makes
    // fetch() fail with a generic "Load failed" error when it's issued right
    // as the page/tab regains foreground focus (e.g. right after switching
    // screens, or the OS briefly suspending the webview). A short delay
    // before the first attempt avoids firing into that window.
    setTimeout(function () { attemptSubmit(1); }, 300);
  }

  function renderResult(scn) {
    var result = exam.result;
    if (!result) {
      // No cached server result (e.g. a page reload landed directly on this
      // screen) — fall back to resubmitting rather than showing a blank screen.
      show('scoring', { replace: true });
      return;
    }

    var localRank = data.ranks.find(function (r) { return r.name === result.rank; });
    var msg = localRank ? localRank.msg : (result.passed ? tr('congrats', 'おめでとうございます。') : tr('tryAgain', 'もう一度挑戦してみましょう。'));

    scn.querySelector('[data-score]').textContent = result.score;
    scn.querySelector('[data-rank]').textContent = result.rank + (result.passed ? tr('certified', '認定') : '');
    scn.querySelector('[data-result-msg]').textContent = msg;
    scn.querySelectorAll('.kt-result-pass').forEach(function (el) {
      el.style.display = result.passed ? '' : 'none';
    });
    scn.querySelectorAll('.kt-result-fail').forEach(function (el) {
      el.style.display = result.passed ? 'none' : '';
    });
  }

  function onOptionClick(e) {
    var btn = e.target.closest('.kt-opt');
    if (!btn) return;
    var scn = btn.closest('[data-screen]');
    if (!scn || scn.classList.contains('is-answered')) return;

    var n = parseInt(scn.dataset.screen.slice(1), 10);
    var q = questionByNumber(n);
    var selectedLetter = btn.getAttribute('data-letter');
    var correct = selectedLetter === q.correct;
    state.answers[q.questionId] = selectedLetter;
    if (correct) state.score += POINTS_PER_QUESTION;
    saveState();

    pushEvent('q' + q.questionId + '_answer', { answer: selectedLetter, correct: correct });
    applyAnswerUI(scn, q, selectedLetter, false);
  }

  function onGoClick(e) {
    var go = e.target.closest('[data-go]');
    if (!go) return;
    var target = go.getAttribute('data-go');
    if (target === 'start') { goStart(); return; }
    if (target === 'retry') {
      pushEvent('kentei_retry');
      state.score = 0;
      state.answers = {};
      saveState();
      exam.status = 'idle';
      exam.result = null;
      saveExam();
      show('intro');
      return;
    }
    if (target === 'retry-submit') { submitExamResult(); return; }
    if (target === 'submit-form') { submitForm(); return; }
    if (target === 'liff-close') {
      if (window.liff && window.liff.isInClient && window.liff.isInClient()) {
        window.liff.closeWindow();
      } else {
        window.location.href = '/';
      }
      return;
    }
    if (target === 'product') {
      pushEvent('product_click');
    }
    show(target);
  }

  // ---- postal code autofill (zipcloud) ----

  function bindZipAutofill() {
    var zipInput = root.querySelector('#kt-zip');
    var addrInput = root.querySelector('#kt-address');
    if (!zipInput || !addrInput) return;
    var timer;
    zipInput.addEventListener('input', function () {
      clearTimeout(timer);
      var digits = zipInput.value.replace(/\D/g, '');
      if (digits.length !== 7) return;
      timer = setTimeout(function () {
        fetch('https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + digits)
          .then(function (res) { return res.json(); })
          .then(function (json) {
            if (json.results && json.results[0]) {
              var r = json.results[0];
              addrInput.value = r.address1 + r.address2 + r.address3;
            }
          })
          .catch(function () {});
      }, 300);
    });
  }

  // ---- form submission ----

  function submitForm() {
    var form = root.querySelector('[data-gift-form]');
    var errorEl = root.querySelector('[data-form-error]');
    var submitBtn = root.querySelector('[data-submit-form]');
    errorEl.hidden = true;

    var fields = {
      name: root.querySelector('#kt-name').value.trim(),
      email: root.querySelector('#kt-email').value.trim(),
      tel: root.querySelector('#kt-tel').value.trim(),
      zip: root.querySelector('#kt-zip').value.trim(),
      address: root.querySelector('#kt-address').value.trim(),
      address2: root.querySelector('#kt-address2').value.trim()
    };

    if (!fields.name || !fields.email || !fields.tel || !fields.zip || !fields.address) {
      errorEl.textContent = tr('errMissing', '未入力の項目があります。ご確認ください。');
      errorEl.hidden = false;
      return;
    }

    var consentEl = root.querySelector('[data-consent-checkbox]');
    if (!consentEl || !consentEl.checked) {
      errorEl.textContent = tr('errConsent', '個人情報の取扱いおよびキャンペーン応募規約への同意が必要です。');
      errorEl.hidden = false;
      return;
    }

    if (sessionStorage.getItem(SUBMITTED_KEY)) {
      show('done');
      return;
    }

    if (!config.appsScriptUrl) {
      console.error('[kentei] Cannot submit gift application: no Apps Script URL configured.');
      errorEl.textContent = tr('errSend', '送信に失敗しました。時間をおいて再度お試しください。');
      errorEl.hidden = false;
      return;
    }

    var idToken = null;
    try {
      if (window.liff && window.liff.getIDToken) idToken = window.liff.getIDToken();
    } catch (e) {
      console.warn('[kentei] liff.getIDToken() failed before gift application submission:', e);
    }

    // LINE User ID is never sent from the client — Apps Script derives it by
    // verifying idToken server-side, then matches it against this user's
    // latest passing exam row.
    var payload = {
      mode: 'present_application',
      idToken: idToken,
      consentAccepted: true,
      name: fields.name,
      email: fields.email,
      phone: fields.tel,
      postalCode: fields.zip,
      address: fields.address + (fields.address2 ? ' ' + fields.address2 : '')
    };

    submitBtn.disabled = true;

    // Same iOS Safari/WebKit "Load failed" timing bug as the exam submission
    // (see submitExamResult) — a short delay before the fetch avoids it.
    setTimeout(function () {
    // text/plain avoids a CORS preflight (OPTIONS) that Apps Script web apps
    // typically do not handle; the Apps Script side should read
    // e.postData.contents and JSON.parse it.
    fetch(config.appsScriptUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.text().then(function (rawText) {
          var json = null;
          try { json = JSON.parse(rawText); } catch (e) { json = null; }
          return json;
        });
      })
      .then(function (json) {
        submitBtn.disabled = false;
        if (!json || json.success !== true) {
          console.error('[kentei] Gift application submission was not successful:', json);
          errorEl.textContent = (json && (json.error || json.message)) || tr('errSend', '送信に失敗しました。時間をおいて再度お試しください。');
          errorEl.hidden = false;
          return;
        }
        try { sessionStorage.setItem(SUBMITTED_KEY, '1'); } catch (e) {}
        pushEvent('gift_submit');
        show('done');
      })
      .catch(function (err) {
        console.error('[kentei] Gift application submission failed:', err);
        submitBtn.disabled = false;
        errorEl.textContent = tr('errSend', '送信に失敗しました。時間をおいて再度お試しください。');
        errorEl.hidden = false;
      });
    }, 300);
  }

  // ---- LIFF ----

  // Always runs once at startup. Calls onReady(targetKey) once the app may proceed,
  // or shows the LIFF-required fallback screen if initialization fails.
  function initLiff(onReady) {
    if (!config.liffId) {
      // No LIFF ID configured yet: proceed as a normal web page (no LINE dependency).
      setTimeout(function () { onReady(); }, 900);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://static.line-scdn.net/liff/edge/2/sdk.js';
    script.onload = function () {
      window.liff.init({ liffId: config.liffId }).then(function () {
        pushEvent('liff_init', { success: true });
        if (!window.liff.isInClient()) {
          console.warn('[kentei] liff.init() succeeded but liff.isInClient() is false (opened outside LINE).');
          show('liff-fallback', { replace: true });
          return;
        }
        // Fire-and-forget: does not gate or delay the existing UI/flow.
        runLiffConnectionTest();
        onReady();
      }).catch(function (err) {
        // Log the real LIFF error so it is visible in devtools / remote debugging
        // (common causes: channel is private and this LINE account has no
        // Developer/Tester role on it, or the registered Endpoint URL does not
        // exactly match this page's URL).
        console.error('[kentei] liff.init() failed:', err && err.code, err && err.message, err);
        pushEvent('liff_init', { success: false, error_code: err && err.code });
        show('liff-fallback', { replace: true });
      });
    };
    script.onerror = function (err) {
      console.error('[kentei] Failed to load the LIFF SDK script.', err);
      show('liff-fallback', { replace: true });
    };
    document.head.appendChild(script);
  }

  // ---- LINE auth connection test (debug only) ----
  //
  // Verifies that liff.getIDToken() -> POST to the Apps Script endpoint round-trips
  // successfully. Only runs when debug_mode is enabled in the section settings.
  // Does not touch scoring, sheet storage, gift application, or Shopify customers,
  // and never renders the ID token or LINE user ID in the visible UI.
  // ok=true shows a quiet, non-interactive "API ✓". ok=false shows a tappable
  // "API ✕" that expands to the short reason on click (never the ID token or
  // LINE user ID itself).
  function setDebugBadge(ok, reason) {
    var badge = root.querySelector('[data-debug-badge]');
    if (!badge) return; // not rendered when debug_mode is off
    badge.hidden = false;
    badge.classList.remove('is-expanded');
    if (ok) {
      badge.dataset.state = 'ok';
      badge.dataset.reason = '';
      badge.textContent = 'API ✓';
    } else {
      badge.dataset.state = 'error';
      badge.dataset.reason = reason || 'LINE認証に失敗しました';
      badge.textContent = 'API ✕';
    }
  }

  function bindDebugBadge() {
    var badge = root.querySelector('[data-debug-badge]');
    if (!badge || badge.dataset.bound) return;
    badge.dataset.bound = 'true';
    badge.addEventListener('click', function () {
      if (badge.dataset.state !== 'error') return;
      var expanded = badge.classList.toggle('is-expanded');
      badge.textContent = expanded ? ('API ✕ ' + badge.dataset.reason) : 'API ✕';
    });
  }

  function runLiffConnectionTest() {
    if (!config.debugMode) return;
    if (!config.appsScriptUrl) {
      console.warn('[kentei][debug] Skipping connection test: no Apps Script URL configured.');
      setDebugBadge(false, 'Apps Script URL未設定');
      return;
    }

    var idToken;
    try {
      idToken = window.liff.getIDToken();
    } catch (e) {
      console.warn('[kentei][debug] liff.getIDToken() threw an error:', e);
      setDebugBadge(false, 'ID token取得エラー');
      return;
    }

    if (!idToken) {
      console.warn('[kentei][debug] liff.getIDToken() returned no token (is the "openid" scope granted for this channel?)');
      setDebugBadge(false, 'ID tokenを取得できませんでした');
      return;
    }

    // Never log or display the token itself — only that one was obtained.
    console.log('[kentei][debug] ID token acquired (length: ' + idToken.length + ')');

    // text/plain avoids a CORS preflight (OPTIONS) that Apps Script web apps
    // typically do not handle; the Apps Script side should read
    // e.postData.contents and JSON.parse it.
    fetch(config.appsScriptUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ idToken: idToken })
    })
      .then(function (res) {
        console.log('[kentei][debug] Apps Script HTTP status:', res.status);
        return res
          .json()
          .catch(function () { return null; })
          .then(function (json) { return { status: res.status, json: json }; });
      })
      .then(function (result) {
        console.log('[kentei][debug] Apps Script response:', result.json);
        var ok = !!(result.json && result.json.success === true);
        console.log('[kentei][debug] success:', ok);

        if (ok) {
          setDebugBadge(true);
        } else {
          // Reason shown only on tap — never the LINE user ID or ID token.
          var reason = (result.json && (result.json.message || result.json.error)) || 'LINE認証に失敗しました';
          setDebugBadge(false, reason);
        }
      })
      .catch(function (err) {
        console.warn('[kentei][debug] Apps Script request failed:', err);
        setDebugBadge(false, '通信エラー');
      });
  }

  // ---- back button handling ----

  window.addEventListener('popstate', function (e) {
    var key = (e.state && e.state.screen) || (location.hash ? location.hash.slice(1) : 'intro');
    if (!screens[key]) key = 'intro';
    show(key, { skipHistory: true });
  });

  // ---- init ----

  fetch(config.questionsUrl)
    .then(function (res) { return res.json(); })
    .then(function (json) {
      data = json;
      collectScreens();
      root.addEventListener('click', function (e) {
        onOptionClick(e);
        onGoClick(e);
      });
      bindZipAutofill();
      bindDebugBadge();

      loadState();
      loadExam();
      var resumeKey = 'intro';
      if (screens[state.screen] && state.screen !== 'boot' && state.screen !== 'liff-fallback') {
        resumeKey = state.screen;
      }

      show('boot', { replace: true });
      initLiff(function () { show(resumeKey, { replace: true }); });
    });
})();
